/* slowride: free gifts that add themselves to the cart (Donovan 2026-11-04; first one: the free mystery hat).
   List: #sr-free-gifts from snippets/sr-free-gift.liquid (the Slowride Sales app's "Free gift" sales). For each gift
   running now and in stock, keeps exactly one in the cart while the rest of the cart (gift lines left out) is at or
   over its minimum, and none otherwise. The sale's own discount makes it free at checkout.
   Runs on page load and after every cart request the theme makes (/cart/add, /cart/change, /cart/update, /cart/clear),
   then asks the drawer to re-render (cart:refresh); on the cart page it reloads. */
(() => {
  const el = document.getElementById('sr-free-gifts');
  if (!el || window.srFreeGift) return;
  let gifts;
  try { gifts = JSON.parse(el.textContent); } catch (e) { return; }
  if (!Array.isArray(gifts)) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const realFetch = window.fetch.bind(window);
  const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const post = (path, body) => realFetch(`${root}${path}`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  const giftIds = new Set(gifts.map((g) => g.variant));
  const running = (g, now) => g.available && (!g.starts || Date.parse(g.starts) <= now) && (!g.ends || Date.parse(g.ends) > now);
  let busy = false;
  let again = false;

  async function check() {
    if (busy) { again = true; return; }
    busy = true;
    let changed = false;
    try {
      const cart = await (await realFetch(`${root}cart.js`, { credentials: 'same-origin' })).json();
      const rest = cart.items.filter((i) => !giftIds.has(i.variant_id));
      const subtotal = rest.reduce((n, i) => n + i.final_line_price, 0);
      const now = Date.now();
      for (const g of gifts) {
        const lines = cart.items.filter((i) => i.variant_id === g.variant);
        const want = running(g, now) && rest.length && subtotal >= g.min ? 1 : 0;
        const have = lines.reduce((n, i) => n + i.quantity, 0);
        if (have === want) continue;
        if (!lines.length) await post('cart/add.js', { items: [{ id: g.variant, quantity: 1 }] });
        else for (let i = 0; i < lines.length; i++) await post('cart/change.js', { id: lines[i].key, quantity: i === 0 ? want : 0 });
        changed = true;
      }
    } catch (e) {
      console.warn('[sr-free-gift]', e);
    } finally {
      busy = false;
      if (changed) {
        if (/\/cart\/?$/.test(location.pathname)) location.reload();
        else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      }
      if (again) { again = false; check(); }
    }
  }

  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = realFetch(input, init);
    if (CART_WRITE.test(url)) p.then(() => setTimeout(check, 0), () => {});
    return p;
  };
  window.srFreeGift = { check };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
  window.addEventListener('pageshow', (e) => { if (e.persisted) check(); });
})();
